import {
  Component,
  OnDestroy,
  HostListener,
  Renderer2,
  Inject,
  ChangeDetectionStrategy,
  DOCUMENT,
} from '@angular/core';

import { CommonModule, CurrencyPipe } from '@angular/common';
import { Product } from '../../../common/product';
import { CartService } from '../../../services/cart.service';
import { NotificationService } from '../../../services/notification.service';
import { ViewStateService } from '@app/services/view-state.service';
import { GalaxyButtonDirective } from '@app/directives/galaxy-button.directive';
import { GalaxyRippleDirective } from '@app/directives/galaxy-ripple.directive';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-quick-view',
  imports: [
    CommonModule,
    CurrencyPipe,
    GalaxyButtonDirective,
    GalaxyRippleDirective,
  ],
  templateUrl: './quick-view.component.html',
  styleUrls: ['./quick-view.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  animations: [
    trigger('modalAnimation', [
      state('void', style({ transform: 'translateY(100%)', opacity: 0 })),
      state('*', style({ transform: 'translateY(0)', opacity: 1 })),
      transition('void => *', [
        animate('300ms cubic-bezier(0.35, 0, 0.25, 1)'),
      ]),
      transition('* => void', [
        animate('300ms cubic-bezier(0.35, 0, 0.25, 1)'),
      ]),
    ]),
  ],
})
export class QuickViewComponent implements OnDestroy {
  product$: Observable<Product | null>;
  product: Product | null = null;
  private productSubscription: Subscription;

  quantity = 1;

  constructor(
    private cartService: CartService,
    private notificationService: NotificationService,
    private viewStateService: ViewStateService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.product$ = this.viewStateService.quickViewProduct$;
    this.productSubscription = this.product$.subscribe((product) => {
      this.product = product;
      if (product) {
        this.quantity = 1; // Reset quantity when a new product is loaded
        this.renderer.setStyle(this.document.body, 'overflow', 'hidden');
      } else {
        this.renderer.removeStyle(this.document.body, 'overflow');
      }
    });
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeModal();
  }

  closeModal(): void {
    this.viewStateService.closeQuickView();
  }

  addToCart(): void {
    if (this.product) {
      this.cartService.addItem(this.product.id, 'full', 'Botella Completa', this.quantity);
      this.notificationService.showSuccess(
        '¡Añadido!',
        `${this.product.name} se ha añadido al carrito.`,
      );
      this.closeModal();
    }
  }

  incrementQuantity(): void {
    this.quantity++;
  }

  decrementQuantity(): void {
    if (this.quantity > 1) {
      this.quantity--;
    }
  }

  ngOnDestroy(): void {
    this.productSubscription.unsubscribe();
    // Ensure style is removed when component is destroyed, e.g., on route change
    this.renderer.removeStyle(this.document.body, 'overflow');
  }
}
